import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  ellipsisApi as api,
  Content,
  ContentWithRelations,
} from '../ellipsisApi';
import { RootState } from '../store';

export const updateContent = createAsyncThunk(
  'content/update',
  async (payload: ContentWithRelations | null, { dispatch }) => {
    if (payload && payload.id) {
      const id = payload.id;
      delete payload.id;
      const result = dispatch(
        api.endpoints.putContentById.initiate({ id: id, content: payload })
      );
      (result as any).unsubscribe();
      await result;
      return { id: id, ...payload };
    }
    return payload;
  }
);

interface ContentState {
  currentContent: Content[];
}

const initialState: ContentState = {
  currentContent: [],
};

const content = createSlice({
  name: 'content',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(updateContent.fulfilled, (state, { payload }) => {
      if (payload) {
        const index = state.currentContent.findIndex(
          (content) => content.id === payload.id
        );
        if (index === -1) {
          state.currentContent.push(payload);
        } else {
          state.currentContent.splice(index, 1);
          state.currentContent.push(payload);
        }
      }
    });
  },
});

export const selectCurrentContent = (state: RootState) =>
  state.content.currentContent;

export default content;
